// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2AqwE","footer":"ReportModalFilter_footer__35t0h"};